<template>
  <div>
    <div v-if="document !== null">
      <a :href="document?.path" target="_blank" class="download-template"
        >Descargar documento {{ titleDocumento }} -
        {{ document?.original_name }}</a
      >
    </div>
    <div v-if="!isEdit">
      <div v-if="file" class="card-file-upload-diagnostic">
        <div class="card-file-upload-diagnostic-text">
          <span>{{ fileName }}</span>
          <p>Archivo cargado</p>
        </div>
        <button>
          <img
            class=""
            :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
            @click.prevent="removeFile"
            :disabled="isBusy"
          />
        </button>
      </div>
      <div v-else>
        <form
          id="file-upload-form"
          class="uploader"
          @dragover.prevent
          @drop="handleDrop"
        >
          <input
            :id="id"
            type="file"
            @change="filesSelected"
            accept=".xlsx, .pdf"
          />
          <label
            for="file-diag"
            id="file-drag"
            class="pointer upload-file-diag"
          >
            <div>
              <img src="@/assets/images/icons/upload-cloud-2-line.svg" />
            </div>
            <p v-if="fileName === ''">
              {{ title }} <span style="color: red" v-if="required">*</span>
            </p>
            <p v-else>{{ fileName }}</p>
            <button id="file-diag-btn" @click.prevent="openFileExplorer">
              Cargar archivo
            </button>
          </label>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    titleDocumento: {
      type: String,
      default: "",
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    document: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      fileName: "",
      file: null,
      host: process.env.VUE_APP_URL_API,
    };
  },
  methods: {
    filesSelected(event) {
      event.preventDefault();
      const me = this;
      const file = document.querySelector(`#${me.id}`);
      me.file = file.files[0];
      me.fileName = file.files[0].name;
      me.validateFile();
    },
    handleDrop(event) {
      const me = this;
      event.preventDefault();
      me.file = event.dataTransfer.files[0];
      me.fileName = me.file.name;
      me.validateFile();
    },
    openFileExplorer() {
      document.querySelector(`#${this.id}`).click();
    },
    validateFile() {
      const me = this;
      if (
        me.file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        me.file.type !== "application/pdf"
      ) {
        me.fileName = "";
        me.file = null;
        this.$bvToast.toast("El archivo debe ser .xlsx o .pdf", {
          title: "Error al subir el archivo",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
          solid: true,
        });
        return false;
      }
      me.$emit("uploadFile", me.file);
    },
    removeFile() {
      const me = this;
      me.fileName = "";
      me.file = null;
      me.$emit("uploadFile", me.file);
    },
  },
};
</script>

<style lang="scss">
.upload-file-diag {
  display: flex !important;
  justify-content: space-between !important;
  gap: 10px !important;
  align-items: center !important;
  padding: 8px !important;
  border-radius: 8px;
  position: relative;
  z-index: 8;
}
.upload-file-diag p {
  font-size: 12px !important;
  margin-bottom: 0 !important;
  text-align: left !important;
  color: #263238 !important;
  width: 300px !important;
}
.upload-file-diag img {
  width: 32px !important;
  height: 32px !important;
}
.upload-file-diag button {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 32px;
  border-radius: 4px;
  font-size: 16px;
  border: none;
  color: white;
  padding: 6px 0px;
  width: 230px;
  justify-content: center;
}
.card-file-upload-diagnostic {
  display: flex;
  justify-content: space-between;
  height: 60px;
  padding: 12px 8px 12px 8px;
  border-radius: 4px;
  border: 1px solid #eceff1;
  background-color: white;
}
.card-file-upload-diagnostic .card-file-upload-diagnostic-text {
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: 12px;
  color: #263238;
}
.card-file-upload-diagnostic .card-file-upload-diagnostic-text p {
  font-size: 12px;
  color: #1719dacf;
}
.card-file-upload-diagnostic button {
  border: none;
  background-color: transparent;
  padding: 0;
}
.download-template {
  display: flex;
  width: 100%;
  font-size: 14px;
  color: #1719dacf;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 10px;
}

.download-template img {
  margin-right: 5px;
}
</style>
